import { useQuery } from "@tanstack/react-query";
import { getAllMailbox, getOneMailbox } from "services/mailbox";

export const useAllMailbox = (filters = {}) => {
  const query = useQuery({
    queryKey: ["all-mailbox", filters],
    queryFn: () => {
      return getAllMailbox(filters);
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
  return query;
};

export const useOneMailbox = (id) => {
  const query = useQuery({
    queryKey: ["one-mailbox", id],
    queryFn: () => {
      if (id) {
        return getOneMailbox(id);
      }
    },
    enabled: !!id,
  });
  return query;
};

